'use client';

import { useTranslations } from 'next-intl';
import { HeroBanner } from '@/components/frontend/common/hero-banner';
import { Testimonials } from '@/components/frontend/home/testimonials';
import { WhoWeAreSection } from './who-we-are-section';
import { OneStopSolutionSection } from './one-stop-solution-section';
import { StatsSection } from './stats-section';
import { DevelopmentProcessSection } from './development-process-section';
import { AboutFeaturesSection } from './about-features-section';

export function AboutPageContent() {
  const t = useTranslations('aboutPage.hero');

  return (
    <div className="min-h-screen bg-white dark:bg-gray-950">
      <HeroBanner
        page="about"
        pill={t('pill')}
        title={t('title')}
        description={t('description')}
      />

      <WhoWeAreSection />

      <OneStopSolutionSection />

      <StatsSection />

      <DevelopmentProcessSection />

      <AboutFeaturesSection />

      <Testimonials />
    </div>
  );
}

